import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AccordionButton = styled(ButtonBase)(({ theme }) => ({
  fontSize: '16px',
  width: '100%',
  justifyContent: 'flex-end',
  '& span': {
    color: theme.palette.secondary.main,
    fontSize: '32px',
  },
  '&:hover': {
    fontWeight: '600',
  },
}));
